/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="b56e97f9-ab85-420b-8542-bf23b3fb05b8" width="29" height="29" viewBox="0 0 29 29" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="ae52d7be-712a-44e8-b3ab-acf1c290a64d" x="0" y="0" width="29" height="29" maskUnits="userSpaceOnUse">
            <g transform="translate(3 3)">
              <g id="b0445e67-64df-44fd-b265-32041712612e">
                <path id="b5c2c7d1-9b16-49f3-8b16-8306f5a40d01" d="M20.8,14.1l-9.93-3.46.34,10.51a9.71,9.71,0,1,1,9.59-7m-.89,2.15c-.12.22-.25.43-.38.63l0,0a9.76,9.76,0,0,1-1.12,1.36l-.15.15c-.15.15-.31.29-.48.43l-.24.2-.46.35-.29.19a4.94,4.94,0,0,1-.49.3l-.28.16-.52.25-.29.13c-.24.1-.48.19-.73.27l-.33.09-.48.13-.32.07-.65.1-.26,0-.29-8.76,8.26,2.88a8.52,8.52,0,0,1-.48,1M11.5.62a10.88,10.88,0,0,0,0,21.76c.23,0,.45,0,.68,0h.19l.36,0c.25,0,.54-.07.87-.13l.26-.06c.21-.05.43-.1.66-.17l.38-.11.52-.19.47-.2.42-.2q.29-.14.57-.3a3.79,3.79,0,0,0,.34-.2,7.66,7.66,0,0,0,.66-.45l.16-.1.11-.1a9.06,9.06,0,0,0,.75-.64l.22-.19c.18-.18.36-.38.53-.57A10.32,10.32,0,0,0,21,16.75,10.87,10.87,0,0,0,11.5.62" fill='#fff' style={{ fillRule: 'evenodd' }}/>
              </g>
            </g>
          </mask>
        </defs>
        <g id="a361ce7f-50a5-4e56-9bd0-0350a8430bdb">
          <g id="bd5636b4-a4fc-4fa6-8eb7-b0c99b908482">
            <g id="a31c694a-70d8-4191-9556-5c37cef9a41c">
              <g id="a98aa4d6-8a92-4104-ac3f-108d51fea954">
                <g id="e7789be5-d005-4627-8ef3-ef5c7a361ff9">
                  <path id="b5554000-afee-4740-929e-1788fa8ee833" d="M20.8,14.1l-9.93-3.46.34,10.51a9.71,9.71,0,1,1,9.59-7m-.89,2.15c-.12.22-.25.43-.38.63l0,0a9.76,9.76,0,0,1-1.12,1.36l-.15.15c-.15.15-.31.29-.48.43l-.24.2-.46.35-.29.19a4.94,4.94,0,0,1-.49.3l-.28.16-.52.25-.29.13c-.24.1-.48.19-.73.27l-.33.09-.48.13-.32.07-.65.1-.26,0-.29-8.76,8.26,2.88a8.52,8.52,0,0,1-.48,1M11.5.62a10.88,10.88,0,0,0,0,21.76c.23,0,.45,0,.68,0h.19l.36,0c.25,0,.54-.07.87-.13l.26-.06c.21-.05.43-.1.66-.17l.38-.11.52-.19.47-.2.42-.2q.29-.14.57-.3a3.79,3.79,0,0,0,.34-.2,7.66,7.66,0,0,0,.66-.45l.16-.1.11-.1a9.06,9.06,0,0,0,.75-.64l.22-.19c.18-.18.36-.38.53-.57A10.32,10.32,0,0,0,21,16.75,10.87,10.87,0,0,0,11.5.62" transform="translate(3 3)" fill='#002b49' style={{ fillRule: 'evenodd' }} className="icon-fill"/>
                </g>
                <g style={{ mask: 'url(#ae52d7be-712a-44e8-b3ab-acf1c290a64d)' }}>
                  <g id="a5a0e334-fd76-4b87-8042-effe0dd6a059">
                    <rect id="a26e0a53-310c-448f-b749-824ba72a4bd3" width="29" height="29" fill='#002b49' className="icon-fill"/>
                  </g>
                </g>
                <g style={{ mask: 'url(#ae52d7be-712a-44e8-b3ab-acf1c290a64d)' }}>
                  <rect id="e94a1c1e-a1ea-4797-a6bc-8bd2e6e2705b" width="29" height="29" className="icon-fill"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

Icon.displayName = 'PieChartIcon';

export default Icon;
